import type { Quaternion, Vector3 } from "../types/primitives";

type Entry = { position: Vector3; orientation: Quaternion };

const registry = new Map<string, Entry>();

/** Remember world pose from MJCF right after merge (before library spawn keyframes overwrite it). */
export function recordMjcfRootDefaultPose(
  bodyUuid: string,
  position: Vector3,
  orientation: Quaternion
): void {
  if (!bodyUuid) return;
  registry.set(bodyUuid, {
    position: [position[0], position[1], position[2]],
    orientation: [orientation[0], orientation[1], orientation[2], orientation[3]],
  });
}

export function getMjcfRootDefaultPose(bodyUuid: string): Entry | null {
  const e = registry.get(bodyUuid);
  if (!e) return null;
  return {
    position: [...e.position] as Vector3,
    orientation: [...e.orientation] as Quaternion,
  };
}

export function clearMjcfRootDefaultPoseRegistry(): void {
  registry.clear();
}
